/* Изпрати.БГ - прозорецът за доставка (#octava-checkout-modal). 12.10.2026, решение на Симеон:
   1) при избран „Наложен платеж“ бутонът казва „Завърши поръчката“ - при наложен платеж Изпрати.БГ създава поръчката
      веднага, без страница за плащане; при карта остава „Продължи“;
   2) цената в картата на избрания офис (там излиза живата цена на куриера, не нашата) се скрива - вярната е в таба и в
      обобщението вдясно.
   13.10.2026:
   3) при смяна на начина на плащане прозорецът преизчислява цените („Обновяване на цените за доставка...“) и за
      няколко секунди пише в сметката вдясно цената на друг вид доставка - 4.50 € при избран офис за 3.50 €. Докато
      трае това, сумите на „Доставка“ и „Общо“ се заменят с „...“. Бутонът през това време е заключен от самия прозорец;
   4) отметката „Фирма“ на прозореца има само име и ЕИК. Когато в количката има „Искам фактура“ и тя не е отметната,
      отметката на прозореца се скрива - фирмените данни се въвеждат на едно място, в количката, с адреса и ДДС
      номера. Отметната „Фирма“ (от „Искам фактура“ или запомнена от предишна поръчка) остава видима.
   25.10.2026 (прегледът за купувачите, задача P298):
   5) редовете на поръчката вдясно - името се вижда цяло, на няколко реда, с разфасовката („... - 100 г“); прозорецът го
      режеше на един ред и седем реда лайка изглеждаха еднакво;
   6) при „По грамаж“ вместо служебното име - грамовете, както в количката: количеството на този вариант е брой десетки
      грамове („15“ = 150 гр.). Значката с броя на този ред се скрива - „15“ се четеше като 15 пакета.
   Ако Изпрати.БГ смени прозореца си, кодът не намира елементите и всичко остава както е при тях - нищо не се чупи.
   Махане: този файл и редът му в layout/theme.liquid. Съобщението до поддръжката им - Workbench/izprati-poddrazhka. */
(function () {
  var PRODALZHI = 'Продължи';
  var ZAVARSHI = 'Завърши поръчката';
  var OBNOVYAVANE = 'Обновяване на цените';   // надписът на бутона, докато прозорецът преизчислява
  var DOSTAVKA = 'Доставка';                  // надписът на реда в сметката
  var PO_GRAMAZH = ' - По грамаж';             // краят на името на реда: прозорецът пише „продукт - вариант“

  var stil = document.createElement('style');
  stil.textContent =
    '#octava-checkout-modal .octava-selected-pickup-price{display:none!important}' +
    '#octava-checkout-modal[data-br-smyata] [data-br-suma]{visibility:hidden;position:relative}' +
    '#octava-checkout-modal[data-br-smyata] [data-br-suma]::after{content:"...";visibility:visible;position:absolute;right:0;top:0}' +
    '#octava-checkout-modal[data-br-bez-faktura] .octava-company-collapsible:not(:has(.octava-company-toggle:checked)){display:none!important}' +
    // без отметката редът с имената е от две колони (над 900 px прозорецът пази трета колона за нея)
    '@media (min-width:901px){#octava-checkout-modal[data-br-bez-faktura] .octava-fields-grid.has-company-toggle:not(:has(.octava-company-toggle:checked)){grid-template-columns:minmax(0,1fr) minmax(0,1fr)}}' +
    '#octava-checkout-modal .octava-summary-item-title{white-space:normal!important;overflow:visible!important;text-overflow:clip!important}' +
    '#octava-checkout-modal .octava-summary-item[data-br-gramove] .octava-summary-item-badge{display:none!important}';
  document.head.appendChild(stil);

  // мярката - от настройката на темата (Търговия), както я пише количката; sections/t4-kolichka.liquid носи data-merka
  function merka() {
    var e = document.querySelector('[data-merka]');
    return (e && e.getAttribute('data-merka')) || 'гр.';
  }

  // 6) редовете „По грамаж“: името завършва на „ - По грамаж“, значката носи броя десетки грамове. Отбелязаният ред вече
  //    завършва на грамове и не се пипа втори път; нарисуван наново от прозореца - отбелязва се наново.
  function gramove(prozorec) {
    var zaglavia = prozorec.querySelectorAll('.octava-summary-item-title');
    for (var i = 0; i < zaglavia.length; i++) {
      var z = zaglavia[i];
      var t = z.textContent.replace(/\s+$/, '');
      if (t.slice(-PO_GRAMAZH.length) !== PO_GRAMAZH) continue;
      var red = z.closest('.octava-summary-item');
      var znachka = red && red.querySelector('.octava-summary-item-badge');
      var broy = znachka ? parseInt(znachka.textContent, 10) : NaN;
      if (!(broy > 0)) continue;   // без броя грамовете не се знаят - редът остава както е
      red.setAttribute('data-br-gramove', '');
      z.textContent = t.slice(0, -PO_GRAMAZH.length) + ' - ' + broy * 10 + ' ' + merka();
    }
  }

  // текстовият възел с надписа в бутона - сменя се само той, другото в бутона (стрелката) остава
  function nadpis(buton) {
    var w = document.createTreeWalker(buton, NodeFilter.SHOW_TEXT, null);
    for (var n = w.nextNode(); n; n = w.nextNode()) {
      if (n.nodeValue.indexOf(PRODALZHI) !== -1 || n.nodeValue.indexOf(ZAVARSHI) !== -1) return n;
    }
    return null;
  }

  // сумите на „Доставка“ и „Общо“ в сметката; отбелязват се всеки път - прозорецът рисува сметката наново
  function sumi(prozorec) {
    var redove = prozorec.querySelectorAll('.octava-summary-row, .octava-summary-total');
    for (var i = 0; i < redove.length; i++) {
      var d = redove[i].children;
      if (d.length !== 2) continue;
      var obshto = redove[i].className.indexOf('octava-summary-total') !== -1;
      if (obshto || d[0].textContent.trim() === DOSTAVKA) d[1].setAttribute('data-br-suma', '');
    }
  }

  function znak(prozorec, ime, da) {
    if (da) prozorec.setAttribute(ime, '');
    else prozorec.removeAttribute(ime);
  }

  function opravi(prozorec) {
    var faktura = document.querySelector('[data-faktura-otmetka]');
    znak(prozorec, 'data-br-bez-faktura', !!faktura && !faktura.checked);
    gramove(prozorec);
    var buton = prozorec.querySelector('.octava-continue-btn');
    if (!buton) return;
    sumi(prozorec);
    znak(prozorec, 'data-br-smyata', buton.textContent.indexOf(OBNOVYAVANE) !== -1);
    var n = nadpis(buton);
    if (!n) return;   // друг надпис (например „Проверка на цената...“) - не се пипа
    var izbrano = prozorec.querySelector('.octava-payment-card.is-selected');
    var nalozhen = !!izbrano && /наложен платеж/i.test(izbrano.textContent);
    var nov = nalozhen ? n.nodeValue.replace(PRODALZHI, ZAVARSHI) : n.nodeValue.replace(ZAVARSHI, PRODALZHI);
    if (nov !== n.nodeValue) n.nodeValue = nov;
  }

  function zakachi() {
    var prozorec = document.getElementById('octava-checkout-modal');
    if (!prozorec || prozorec.getAttribute('data-br-popravki')) return;
    prozorec.setAttribute('data-br-popravki', '1');
    opravi(prozorec);
    new MutationObserver(function () { opravi(prozorec); })
      .observe(prozorec, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }

  // прозорецът се добавя в body при „Към плащане“
  new MutationObserver(zakachi).observe(document.body, { childList: true });
  zakachi();
})();
